import {  useSelector } from "react-redux";
import RelatedSinglePost from "./RelatedSinglePost";


export default function RelatedPost() {
    const { relatedPosts, isLoading, isError, error } = useSelector(
        (state) => state.relatedPosts
    );


    // decide what to render
    let content;

    if (isLoading) content = "Loading";
    if (!isLoading && isError)
        content = <div>{error}</div>;

    if (!isError && !isLoading && relatedPosts?.length === 0) {
        content = <div>No Posts found!</div>;
    }

    if (!isError && !isLoading && relatedPosts?.length > 0) {
        content = relatedPosts.map((post) => (
            <RelatedSinglePost key={post.id} post={post} />
        ));
    }
    return (
        <aside>
            <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">Related Posts</h4>
            <div className="space-y-4 related-post-container">
                {content}
            </div>
        </aside>
    )
};